/**
 * After this many successful user prompts in a row, context is reset: the last
 * edited image becomes the new base URL and accumulated attachments are cleared.
 */
export const PROMPTS_CHECKPOINT_SIZE = 3;

export const mergeAttachmentUrls = (previousUrls, incomingUrls) => {
  const merged = [...previousUrls];
  const safeIncoming = Array.isArray(incomingUrls) ? incomingUrls : [];

  for (const url of safeIncoming) {
    if (url && !merged.includes(url)) {
      merged.push(url);
    }
  }

  return merged;
};

export const mergeAttachmentFileNames = (previousNames, incomingNames) => ({
  ...previousNames,
  ...(incomingNames && typeof incomingNames === "object" ? incomingNames : {}),
});
